import {
    FormControlLabel,
    FormHelperText,
    Switch
} from '@mui/material';

const OdooStockSyncSwitch = ({
    checked,
    disabled = false,
    onChange,
    showHelp = true
}) => (
    <>
        <FormControlLabel
            control={
                <Switch
                    checked={Boolean(checked)}
                    disabled={disabled}
                    name="sync_odoo_stock"
                    onChange={onChange}
                />
            }
            label="Permitir que Odoo actualice el stock ONL"
        />
        {
            showHelp &&
            <FormHelperText>
                Al desactivarlo se conserva el ID para consulta, pero Odoo no
                sobrescribirá las existencias de la tienda.
            </FormHelperText>
        }
    </>
);

export default OdooStockSyncSwitch;
